import React from "react";
import {getBaseURL} from "components/helpers/HostURLHelper.jsx";
import PropTypes from 'prop-types';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import $ from 'jquery';

class DatasetQuestionLevels extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      patterns: [],
    };
  }

  static propTypes = {
    value: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    change: PropTypes.func.isRequired
  };

  componentDidMount(){
    const topicId = this.props.topicId;
    const level = this.props.level;
    if(topicId && level){
      $.ajax({
        type: 'GET',
        url: getBaseURL() + '/get-topic-level-patterns.json?topic_id='+ topicId +'&level='+level+'&source=dataset'
      }).done((response, status, jqXHR)=>{
          this.setState({
            patterns: response
          });

      });
    }
  }

  componentDidUpdate(prevProps){
    if(this.props.topicId != prevProps.topicId || this.props.level != prevProps.level){
      const topicId = this.props.topicId;
      const level = this.props.level;
      if(topicId && level){
        $.ajax({
          type: 'GET',
          url: getBaseURL() + '/get-topic-level-patterns.json?topic_id='+ topicId +'&level='+level+'&source=dataset'
        }).done((response, status, jqXHR)=>{
            this.setState({
              patterns: response
            });

        });
      }
    }
  }

  getIdForLOV(value){
    const patterns = this.state.patterns;
    const filteredPatterns = patterns.filter(pattern => pattern.name == value);
    if (filteredPatterns && filteredPatterns.length > 0){
     return {id: filteredPatterns[0].id};
    }
    return {id: ""};
  }


  render() {
    const { name, value, index, change,formControlWidth, includeId, topicId,level } = this.props;
    return (
      <FormControl style={ formControlWidth ? {width: formControlWidth} : null}>
        <Select value={value} name={name} onChange={includeId ? (e) => change(e,this.getIdForLOV(e.target.value)) :change} 
          style={{fontSize: 'inherit'}}>
          <MenuItem key={index} style={{fontSize: "14px"}} value={"All"}>{"All"}</MenuItem>
          { this.state.patterns.map((pattern, index) =>
            <MenuItem key={index} style={{fontSize: "14px"}} value={pattern.name}>{pattern.name}</MenuItem>
          )}
        </Select>
      </FormControl>
    );
  }

}


export default DatasetQuestionLevels;